import { totalDailyEnergyExpenditure } from './calc.js';
import { MIN_DAILY_KCAL } from './nutrition.js';
import { validDiaryDate } from './diary-date.js';
/** Краткосрочный сценарий энергетического баланса, НЕ клиническая модель NIH.
 * Каждый день расход пересчитывается для новой массы. 7700 ккал/кг — грубое
 * допущение: не учитывает воду, состав тела, адаптацию и ошибки оценки расхода.
 * Ограничиваем горизонт 90 днями и не строим сценарий похудения ниже BMI 18.5.
 * https://www.niddk.nih.gov/health-information/professionals/diabetes-discoveries-practice/nih-body-weight-planner
 */
export function weightForecast(profile, dailyKcal, startDate, days = 30) {
    if (profile.ageYears < 18 || !validDiaryDate(startDate) || !Number.isFinite(dailyKcal) || dailyKcal < MIN_DAILY_KCAL[profile.sex])
        return [];
    const horizon = Math.max(1, Math.min(90, Math.floor(days)));
    const minWeight = Math.max(25, 18.5 * (profile.heightCm / 100) ** 2);
    const losing = dailyKcal < totalDailyEnergyExpenditure(profile);
    if (losing && profile.weightKg <= minWeight)
        return [];
    let weight = profile.weightKg;
    const points = [];
    for (let day = 0; day <= horizon; day++) {
        const date = new Date(`${startDate}T12:00:00Z`);
        date.setUTCDate(date.getUTCDate() + day);
        points.push({ date: date.toISOString().slice(0, 10), weightKg: Math.round(weight * 100) / 100 });
        const expenditure = totalDailyEnergyExpenditure({ ...profile, weightKg: weight });
        const next = weight + (dailyKcal - expenditure) / 7700;
        if (next < minWeight && losing || next < 25 || next > 400)
            break;
        weight = next;
    }
    return points;
}
//# sourceMappingURL=weight-forecast.js.map